const LOCAL_ROUTE_BASE_URL = 'https://paperzilla.invalid';
const LEGACY_PREVIEW_TRIAL_PATH = '/trial';
const CANONICAL_PREVIEW_TRIAL_PATH = '/trial/preview';
const PREVIEW_TRIAL_QUERY_KEYS = new Set([
    'preview_project_id',
    'result_digest_id',
]);

export function normalizePublicDigestPreviewTrialPath({
    trialPath,
    projectId,
    digestId,
}: {
    trialPath: string;
    projectId: string;
    digestId: string;
}): string | null {
    if (
        !trialPath.startsWith('/')
        || trialPath.startsWith('//')
        || trialPath.includes('\\')
        || !projectId.trim()
        || !digestId.trim()
    ) {
        return null;
    }

    const rawPathname = trialPath.split(/[?#]/, 1)[0];
    if (
        rawPathname !== LEGACY_PREVIEW_TRIAL_PATH
        && rawPathname !== CANONICAL_PREVIEW_TRIAL_PATH
    ) {
        return null;
    }

    let parsed: URL;
    try {
        parsed = new URL(trialPath, LOCAL_ROUTE_BASE_URL);
    } catch {
        return null;
    }

    if (
        parsed.origin !== LOCAL_ROUTE_BASE_URL
        || parsed.hash
        || parsed.pathname !== rawPathname
    ) {
        return null;
    }

    const queryKeys = Array.from(parsed.searchParams.keys());
    if (
        queryKeys.length !== PREVIEW_TRIAL_QUERY_KEYS.size
        || queryKeys.some((key) => !PREVIEW_TRIAL_QUERY_KEYS.has(key))
        || parsed.searchParams.getAll('preview_project_id').length !== 1
        || parsed.searchParams.getAll('result_digest_id').length !== 1
        || parsed.searchParams.get('preview_project_id') !== projectId
        || parsed.searchParams.get('result_digest_id') !== digestId
    ) {
        return null;
    }

    const canonicalParams = new URLSearchParams({
        preview_project_id: projectId,
        result_digest_id: digestId,
    });
    return `${CANONICAL_PREVIEW_TRIAL_PATH}?${canonicalParams.toString()}`;
}
